var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-main-content",
      attrs: {
        "element-loading-spinner": "none",
        "element-loading-background": "rgba(170,170,170,0)"
      }
    },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                ref: "searchItem",
                attrs: { "config-module": "920" },
                on: {
                  "click-more": function(value) {
                    _vm.isAdvancedQuery = value
                  },
                  simSearchItemCallBack: function($event) {
                    return _vm.toAdvancedQuery()
                  },
                  advSearchItemCallBack: _vm.toAdvancedQuery
                }
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: { display: "flex" },
                    attrs: { slot: "operations" },
                    slot: "operations"
                  },
                  [
                    _c("span", { staticStyle: { color: "#666666" } }, [
                      _vm._v("ETD")
                    ]),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100px", "margin-left": "5px" },
                        attrs: { no: "1", filterable: "" },
                        on: { change: _vm.onTimeRangeChange },
                        model: {
                          value: _vm.timeRange,
                          callback: function($$v) {
                            _vm.timeRange = $$v
                          },
                          expression: "timeRange"
                        }
                      },
                      _vm._l(_vm.TIME_RANGES, function(item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            label: _vm.isZh
                              ? item.chineseName
                              : item.englishName,
                            value: item.code
                          }
                        })
                      }),
                      1
                    ),
                    _c("el-date-picker", {
                      staticStyle: { width: "120px", margin: "0 5px" },
                      attrs: {
                        no: "2",
                        disabled: _vm.timeRange !== _vm.CUSTOM.code,
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        editable: false,
                        clearable: false
                      },
                      model: {
                        value: _vm.commonFilter.start,
                        callback: function($$v) {
                          _vm.$set(_vm.commonFilter, "start", $$v)
                        },
                        expression: "commonFilter.start"
                      }
                    }),
                    _vm._v("- "),
                    _c("el-date-picker", {
                      staticStyle: { width: "120px", "margin-left": "5px" },
                      attrs: {
                        no: "3",
                        disabled: _vm.timeRange !== _vm.CUSTOM.code,
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        editable: false,
                        clearable: false
                      },
                      model: {
                        value: _vm.commonFilter.end,
                        callback: function($$v) {
                          _vm.$set(_vm.commonFilter, "end", $$v)
                        },
                        expression: "commonFilter.end"
                      }
                    }),
                    _c("cargo-advance-select", {
                      staticStyle: { width: "150px", margin: "0 5px" },
                      attrs: {
                        no: "4",
                        "select-type": _vm.TYPE_NAMES.basic_data_Region,
                        filterable: "",
                        multiple: true,
                        "default-multiple-value": _vm.commonFilter.regions,
                        "tag-name": _vm.isZh ? "name" : "nameEnglish",
                        placeholder:
                          "-" + _vm.$t("CargoMsg.Cargo_Airline") + "-"
                      },
                      on: {
                        parentCallBack: function(p) {
                          _vm.commonFilter.regions = p.value
                        }
                      }
                    }),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.$checkPermission([
                              "button_AERouteCentral_Booking"
                            ]),
                            expression:
                              "$checkPermission(['button_AERouteCentral_Booking'])"
                          }
                        ],
                        attrs: {
                          no: "5",
                          disabled: !(
                            _vm.validFlight &&
                            _vm.bookingEnable &&
                            _vm.selectedRow.settleState === 0
                          ),
                          type: "primary"
                        },
                        on: { click: _vm.bookingHandler }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Booking")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.$checkPermission([
                              "button_AERouteCentral_ExportLoading"
                            ]),
                            expression:
                              "$checkPermission(['button_AERouteCentral_ExportLoading'])"
                          }
                        ],
                        attrs: {
                          no: "6",
                          disabled: !(
                            _vm.selectedRow &&
                            (_vm.validFlight ||
                              _vm.selectedRow.departureTime === "Co-Loader" ||
                              _vm.exportTemplateEnabled)
                          ),
                          type: "primary"
                        },
                        on: {
                          click: function($event) {
                            return _vm.exportTemplateHandler(
                              "FLIGHTLOADINGPLAN"
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("queryJob.exportLoadingPlan")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.$checkPermission([
                              "button_AERouteCentral_ExportSaleReport"
                            ]),
                            expression:
                              "$checkPermission(['button_AERouteCentral_ExportSaleReport'])"
                          }
                        ],
                        attrs: {
                          no: "7",
                          disabled: !(
                            _vm.selectedRow &&
                            (_vm.validFlight ||
                              _vm.selectedRow.departureTime === "Co-Loader" ||
                              _vm.exportTemplateEnabled)
                          ),
                          type: "success"
                        },
                        on: {
                          click: function($event) {
                            return _vm.exportTemplateHandler("AESALESREPORT")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Print")))]
                    ),
                    _c(
                      "el-menu",
                      {
                        staticClass:
                          "el-menu-button el-button el-button--primary el-button--mini",
                        style: {
                          width: _vm.$selectByLang(
                            "110px",
                            "110px",
                            "110px",
                            "200px",
                            "200px",
                            "200px"
                          ),
                          padding: "0"
                        },
                        attrs: {
                          no: "8",
                          "text-color": "#404144",
                          "active-text-color": "#404144",
                          mode: "horizontal"
                        },
                        on: { select: _vm.menuBarItemClickHandler }
                      },
                      [
                        _c(
                          "el-submenu",
                          { attrs: { index: "moreOperator" } },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "el-menu-btn-text",
                                attrs: { slot: "title" },
                                slot: "title"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("queryJob.moreOperations"))
                                )
                              ]
                            ),
                            _c(
                              "el-submenu",
                              { attrs: { index: "template" } },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("queryJob.routeOperation"))
                                  )
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: [
                                          "button_AERouteCentral_BookingDone"
                                        ],
                                        expression:
                                          "['button_AERouteCentral_BookingDone']"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btBookingDoneEnabled,
                                      index: "btBookingDone"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("queryJob.completeBooking"))
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: [
                                          "button_AERouteCentral_WarehouseEntry"
                                        ],
                                        expression:
                                          "['button_AERouteCentral_WarehouseEntry']"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btBookingInEnabled,
                                      index: "btBookingIn"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("queryJob.warehousing"))
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: [
                                          "button_AERouteCentral_LoadingBoard"
                                        ],
                                        expression:
                                          "['button_AERouteCentral_LoadingBoard']"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btLoadingEnabled,
                                      index: "btLoading"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("queryJob.mountingBoard"))
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: ["button_AERouteCentral_PullIn"],
                                        expression:
                                          "['button_AERouteCentral_PullIn']"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btPullInEnabled,
                                      index: "btPullIn"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("queryJob.pullGood")))]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: [
                                          "button_AERouteCentral_AdjustFlight"
                                        ],
                                        expression:
                                          "['button_AERouteCentral_AdjustFlight']"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btAdjustFlightEnabled,
                                      index: "btAdjustFlight"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "queryJob.applicationForFlightAdjustment"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      disabled: !_vm.btMixFlightEnabled,
                                      index: "btMixFlight"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("queryJob.allocateFlights"))
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      disabled: !_vm.btCheckBookingEnabled,
                                      index: "btCheckBooking"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "queryJob.confirmCabinAllocation"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    attrs: {
                                      disabled: !_vm.btCancelCheckBookingEnabled,
                                      index: "btCancelCheckBooking"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "queryJob.cancelConfirmationOfCabinAllocation"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: [
                                          "button_AERouteCentral_CopyWarehouseInfo"
                                        ],
                                        expression:
                                          "['button_AERouteCentral_CopyWarehouseInfo']"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btCopyWarehouseInfoEnabled,
                                      index: "btCopyWarehouseInfo"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("queryJob.copyIncomingData")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: [
                                          "button_AERouteCentral_OperatorRemarks"
                                        ],
                                        expression:
                                          "['button_AERouteCentral_OperatorRemarks']"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btOperatorRemarksEnabled,
                                      index: "btOperatorRemarks"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("SeaExport.AdditionalNotes")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: [
                                          "button_AERouteCentral_OtherWarehouseNotes"
                                        ],
                                        expression:
                                          "['button_AERouteCentral_OtherWarehouseNotes']"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btOtherWarehouseNotesEnabled,
                                      index: "btOtherWarehouseNotes"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("queryJob.otherRemarks"))
                                    )
                                  ]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-submenu",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.moreOperatorVisible.operatorVisible,
                                    expression:
                                      "moreOperatorVisible.operatorVisible"
                                  }
                                ],
                                attrs: { index: "operator" }
                              },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.FieldOperation"))
                                  )
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.moreOperatorVisible.operator
                                            .btDeclareCustoms,
                                        expression:
                                          "moreOperatorVisible.operator.btDeclareCustoms"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btDeclareCustomsEnabled,
                                      index: "btDeclareCustoms"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_CustomsDeclaration"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.moreOperatorVisible.operator
                                            .btSiteRemark,
                                        expression:
                                          "moreOperatorVisible.operator.btSiteRemark"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btSiteRemarkEnabled,
                                      index: "btSiteRemark"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "SeaExport.OperatingInstructions"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.moreOperatorVisible.operator
                                            .btOtherCharges,
                                        expression:
                                          "moreOperatorVisible.operator.btOtherCharges"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btOtherChargesEnabled,
                                      index: "btOtherCharges"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("queryJob.otherExpenses"))
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.moreOperatorVisible.operator
                                            .btDelivery,
                                        expression:
                                          "moreOperatorVisible.operator.btDelivery"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btDeliveryEnabled,
                                      index: "btDelivery"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("queryJob.delivery")))]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.moreOperatorVisible.operator
                                            .btDeliveryAgent,
                                        expression:
                                          "moreOperatorVisible.operator.btDeliveryAgent"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btDeliveryAgentEnabled,
                                      index: "btDeliveryAgent"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("queryJob.deliveryAgent"))
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.moreOperatorVisible.operator
                                            .btUploadLoadingPic,
                                        expression:
                                          "moreOperatorVisible.operator.btUploadLoadingPic"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btUploadLoadingPicEnabled,
                                      index: "btUploadLoadingPic"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("queryJob.uploadBoardPhotos")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.moreOperatorVisible.operator
                                            .btLabel,
                                        expression:
                                          "moreOperatorVisible.operator.btLabel"
                                      }
                                    ],
                                    attrs: {
                                      disabled: _vm.curDataType !== 6,
                                      index: "btLabel"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("queryJob.subLabel")))]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-menu-item",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.moreOperatorVisible
                                      .operatorVisible,
                                    expression:
                                      "!moreOperatorVisible.operatorVisible"
                                  }
                                ],
                                attrs: { index: "operator" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.FieldOperation"))
                                )
                              ]
                            ),
                            _c(
                              "el-submenu",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.moreOperatorVisible.billVisible,
                                    expression:
                                      "moreOperatorVisible.billVisible"
                                  }
                                ],
                                attrs: { index: "bill" }
                              },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.Documentation"))
                                  )
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.moreOperatorVisible.bill
                                            .btBillingMAWB,
                                        expression:
                                          "moreOperatorVisible.bill.btBillingMAWB"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btBillingMAWBEnabled,
                                      index: "btBillingMAWB"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "queryJob.prefabricatedMasterOrder"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.moreOperatorVisible.bill
                                            .btBillingHAWB,
                                        expression:
                                          "moreOperatorVisible.bill.btBillingHAWB"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btBillingHAWBEnabled,
                                      index: "btBillingHAWB"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "queryJob.prefabricationOrderSplitting"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.moreOperatorVisible.bill
                                            .btPrintMAWB,
                                        expression:
                                          "moreOperatorVisible.bill.btPrintMAWB"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btPrintMAWBEnabled,
                                      index: "btPrintMAWB"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("queryJob.printMasterOrder")
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.moreOperatorVisible.bill
                                            .btPrintHAWB,
                                        expression:
                                          "moreOperatorVisible.bill.btPrintHAWB"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btPrintHAWBEnabled,
                                      index: "btPrintHAWB"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("queryJob.printSplit"))
                                    )
                                  ]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-menu-item",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.moreOperatorVisible.billVisible,
                                    expression:
                                      "!moreOperatorVisible.billVisible"
                                  }
                                ],
                                attrs: { index: "bill" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.Documentation"))
                                )
                              ]
                            ),
                            _c(
                              "el-submenu",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.moreOperatorVisible.trackVisible,
                                    expression:
                                      "moreOperatorVisible.trackVisible"
                                  }
                                ],
                                attrs: { index: "track" }
                              },
                              [
                                _c("template", { slot: "title" }, [
                                  _vm._v(_vm._s(_vm.$t("queryJob.track")))
                                ]),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.moreOperatorVisible.track
                                            .btTakeOff,
                                        expression:
                                          "moreOperatorVisible.track.btTakeOff"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btTakeOffEnabled,
                                      index: "btTakeOff"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("queryJob.takeOff")))]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.moreOperatorVisible.track
                                            .btArrival,
                                        expression:
                                          "moreOperatorVisible.track.btArrival"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btArrivalEnabled,
                                      index: "btArrival"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("queryJob.arrival")))]
                                ),
                                _c(
                                  "el-menu-item",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.moreOperatorVisible.track
                                            .btFlightState,
                                        expression:
                                          "moreOperatorVisible.track.btFlightState"
                                      }
                                    ],
                                    attrs: {
                                      disabled: !_vm.btFlightStateEnabled,
                                      index: "btFlightState"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.btFlightStateLabel))]
                                )
                              ],
                              2
                            ),
                            _c(
                              "el-menu-item",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.moreOperatorVisible
                                      .trackVisible,
                                    expression:
                                      "!moreOperatorVisible.trackVisible"
                                  }
                                ],
                                attrs: { index: "track" }
                              },
                              [_vm._v(_vm._s(_vm.$t("queryJob.track")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "9", type: "primary" },
                        on: { click: _vm.queryJobMbl }
                      },
                      [_vm._v(_vm._s(_vm.$t("queryJob.billOfLadingInquiry")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "10", type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.gridApi.expandAll()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("queryJob.expandAll")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { no: "11", type: "primary" },
                        on: { click: _vm.onCollapseFlights }
                      },
                      [_vm._v(_vm._s(_vm.$t("queryJob.putItAllAway")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { margin: "0 5px 0 15px" },
                        attrs: { no: "12" },
                        on: { change: _vm.resetTimer },
                        model: {
                          value: _vm.autoRefresh,
                          callback: function($$v) {
                            _vm.autoRefresh = $$v
                          },
                          expression: "autoRefresh"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("SeaExport.AutomaticallyRefresh")))]
                    ),
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { margin: "0 5px" },
                        attrs: { no: "13" },
                        model: {
                          value: _vm.showAll,
                          callback: function($$v) {
                            _vm.showAll = $$v
                          },
                          expression: "showAll"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("queryJob.noBusinessFlight")))]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "section grid-wrapper",
                staticStyle: { "min-height": "350px" }
              },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    no: "grid",
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                    "check-main-record": false,
                    "deselect-main-record": false,
                    "deselect-sub-record": true,
                    "auto-fit-content": false,
                    "shift-select": true,
                    "ctrl-select": true
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.gridApi = params.api
                    },
                    shiftSelects: _vm.onShiftOrCtrlSelects,
                    ctrlSelects: _vm.onShiftOrCtrlSelects,
                    rowGroupOpened: _vm.onRowSpanMethod,
                    expandOrCollapseAll: _vm.onRowSpanMethod
                  }
                }),
                _vm.keyboardSelectStatistics.visible
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          position: "fixed",
                          "margin-left": "50%",
                          padding: "5px 5px 5px 30px",
                          border: "1px solid #bdc3c7",
                          background: "#FFFFCC"
                        }
                      },
                      [
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm.keyboardSelectStatistics.quantityContract
                            )
                          )
                        ]),
                        _c("b", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.keyboardSelectStatistics.weightContract.toFixed(
                                1
                              )
                            )
                          )
                        ]),
                        _c("b", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.keyboardSelectStatistics.cubageContract.toFixed(
                                3
                              )
                            )
                          )
                        ]),
                        _c("b", { staticStyle: { "margin-left": "40px" } }, [
                          _vm._v(
                            _vm._s(_vm.keyboardSelectStatistics.quantityActual)
                          )
                        ]),
                        _c("b", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.keyboardSelectStatistics.weightActual.toFixed(
                                1
                              )
                            )
                          )
                        ]),
                        _c("b", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.keyboardSelectStatistics.cubageActual.toFixed(
                                3
                              )
                            )
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            ),
            _c("div", [
              _c("div", { staticStyle: { display: "flex", float: "right" } }, [
                _c("b", [_vm._v(_vm._s(_vm.$t("SeaExport.Actual")))]),
                _c("div", { staticStyle: { padding: "0 10px" } }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.Piece")))
                ]),
                _c("b", [_vm._v(_vm._s(_vm.quantityActual))]),
                _c("div", { staticStyle: { padding: "0 10px" } }, [
                  _vm._v(_vm._s(_vm.$t("queryJob.heavy")))
                ]),
                _c("b", [_vm._v(_vm._s(_vm.weightActual.toFixed(1)))]),
                _c("div", { staticStyle: { padding: "0 10px" } }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.Volume")))
                ]),
                _c("b", [_vm._v(_vm._s(_vm.cubageActual.toFixed(3)))]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "padding-left": "10px",
                      "font-weight": "bold"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Consignation")))]
                ),
                _c("div", { staticStyle: { padding: "0 10px" } }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.Piece")))
                ]),
                _c("b", [_vm._v(_vm._s(_vm.quantityContract))]),
                _c("div", { staticStyle: { padding: "0 10px" } }, [
                  _vm._v(_vm._s(_vm.$t("queryJob.heavy")))
                ]),
                _c("b", [_vm._v(_vm._s(_vm.weightContract.toFixed(1)))]),
                _c("div", { staticStyle: { padding: "0 10px" } }, [
                  _vm._v(_vm._s(_vm.$t("SeaExport.Volume")))
                ]),
                _c("b", [_vm._v(_vm._s(_vm.cubageContract.toFixed(3)))])
              ])
            ])
          ],
          1
        )
      ]),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("booking-dialog", {
        attrs: {
          visible: _vm.bookingDialog.visible,
          flight: _vm.bookingDialog.flight,
          jobs: _vm.bookingDialog.jobs
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.bookingDialog, "visible", $event)
          }
        }
      }),
      _c("query-mbl-dialog", {
        attrs: { visible: _vm.queryMblDialog.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.queryMblDialog, "visible", $event)
          },
          callback: _vm.queryMblCallback
        }
      }),
      _c("mix-flight-dialog", {
        attrs: {
          visible: _vm.mixFlightDialog.visible,
          jobs: _vm.mixFlightDialog.jobs
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.mixFlightDialog, "visible", $event)
          },
          callback: function($event) {
            return _vm.toAdvancedQuery()
          }
        }
      }),
      _c("loading-note-dialog", {
        attrs: {
          visible: _vm.loadingNoteDialog.visible,
          jobs: _vm.loadingNoteDialog.jobs
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.loadingNoteDialog, "visible", $event)
          },
          callback: function($event) {
            return _vm.onRowSpanMethod({ api: _vm.gridApi })
          }
        }
      }),
      _c("warehouse-entry-dialog", {
        attrs: {
          visible: _vm.warehouseEntryDialog.visible,
          job: _vm.warehouseEntryDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.warehouseEntryDialog, "visible", $event)
          },
          callback: function($event) {
            return _vm.toAdvancedQuery()
          }
        }
      }),
      _c("booking-done-dialog", {
        attrs: {
          visible: _vm.bookingDoneDialog.visible,
          flight: _vm.bookingDoneDialog.flight
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.bookingDoneDialog, "visible", $event)
          }
        }
      }),
      _c("declare-customs-dialog", {
        attrs: {
          visible: _vm.declareCustomsDialog.visible,
          job: _vm.declareCustomsDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.declareCustomsDialog, "visible", $event)
          }
        }
      }),
      _c("operator-remark-dialog", {
        attrs: {
          visible: _vm.operatorRemarkDialog.visible,
          "operator-id": _vm.operatorRemarkDialog.operatorId,
          job: _vm.operatorRemarkDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.operatorRemarkDialog, "visible", $event)
          },
          callback: function($event) {
            return _vm.gridApi.setRowData(_vm.rowData)
          }
        }
      }),
      _c("update-flight-dialog", {
        attrs: {
          visible: _vm.updateFlightDialog.visible,
          operation: _vm.updateFlightDialog.operation,
          flight: _vm.updateFlightDialog.flight
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.updateFlightDialog, "visible", $event)
          },
          callback: function($event) {
            return _vm.gridApi.setRowData(_vm.rowData)
          }
        }
      }),
      _c("deliver-agent-dialog", {
        attrs: {
          visible: _vm.deliverAgentDialog.visible,
          jobs: _vm.deliverAgentDialog.jobs
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.deliverAgentDialog, "visible", $event)
          },
          callback: function($event) {
            return _vm.gridApi.refreshCells({ force: true })
          }
        }
      }),
      _c("upload-loading-pic-dialog", {
        attrs: {
          visible: _vm.uploadLoadingPicDialog.visible,
          job: _vm.uploadLoadingPicDialog.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.uploadLoadingPicDialog, "visible", $event)
          }
        }
      }),
      _c("warehouse-label-dialog", {
        attrs: {
          visible: _vm.warehouseLabelDialog.visible,
          job: _vm.warehouseLabelDialog.job,
          "warehouse-in": _vm.warehouseLabelDialog.warehouseIn
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.warehouseLabelDialog, "visible", $event)
          },
          callback: _vm.onWarehouseLabelChange
        }
      }),
      _c("billingDialog", {
        attrs: {
          no: "billingDialog",
          visible: _vm.billingDialog.visible,
          job: _vm.billingDialog.job,
          "doc-type": _vm.billingDialog.docType
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billingDialog, "visible", $event)
          },
          callback: _vm.delayUpdateButtonState
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }